
const state = {
  actualtotal: '',
  invoice_date: '',
  invoice_notes: '',
  invoice_reference: '',
  invoice_total: undefined,
  paid_by: '',
}

export const requiredFields = [
  { key: 'invoice_date' },
  { key: 'invoice_reference' },
]

export default state
